import { Avatar, Button, Form, Input, message } from "antd";
import React, { useState } from "react";
import LOGO from "../../assets/fastest-logo.jpg.png";
import { selectBaseUrl, selectProdTestUrl } from "../../redux/slices/envSlice";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const ForgotPassword = () => {
  const baseUrl = useSelector(selectBaseUrl);
  const prodTestUrl = useSelector(selectProdTestUrl);
  const [currentStep, setCurrentStep] = useState(0); // 0: Ask OTP, 1: Verify OTP, 2: Reset Password
  const [email, setEmail] = useState(""); // State to store the email

  const handleFormFinish = async (values) => {
    switch (currentStep) {
      case 0:
        // Handle sending OTP logic
        const { email: enteredEmail } = values; // Get the email from form values
        setEmail(enteredEmail); // Save the email to state for later use
        console.log("Requesting OTP for:", enteredEmail);

        try {
          const response = await fetch(
            `${prodTestUrl ? prodTestUrl : baseUrl}/api/admin-ask-otp/`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ email: enteredEmail }), // Send email to request OTP
            }
          );

          if (!response.ok) {
            throw new Error("Failed to send OTP");
          }

          message.success("OTP sent successfully."); // Success message
          setCurrentStep(1); // Move to OTP verification step
        } catch (error) {
          console.error("Error:", error);
          message.error(
            error.message || "An error occurred while sending OTP."
          ); // Error message
        }
        break;

      case 1:
        // Handle OTP verification logic
        const { verify_otp } = values;
        console.log("Verifying OTP for email:", email, "OTP:", verify_otp);

        try {
          const response = await fetch(
            `${prodTestUrl ? prodTestUrl : baseUrl}/api/admin-verify-otp/`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ otp: verify_otp, email }), // Send OTP and email
            }
          );

          if (!response.ok) {
            throw new Error("Invalid OTP");
          }

          message.success("OTP verified successfully."); // Success message
          setCurrentStep(2); // Move to password reset step
        } catch (error) {
          console.error("Error:", error);
          message.error(
            error.message || "An error occurred while verifying OTP."
          ); // Error message
        }
        break;

      case 2:
        // Handle password reset logic
        const { password, new_password } = values;
        if (password === new_password) {
          console.log("Resetting password to:", password, email);

          try {
            const response = await fetch(
              `${
                prodTestUrl ? prodTestUrl : baseUrl
              }/api/admin-reset-password/`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({ new_password: password, email: email }), // Send new password and email
              }
            );

            if (!response.ok) {
              throw new Error("Failed to reset password");
            }

            message.success("Password reset successfully."); // Success message
            // Optionally navigate to the login page or show a success message
          } catch (error) {
            console.error("Error:", error);
            message.error(
              error.message || "An error occurred while resetting the password."
            ); // Error message
          }
        } else {
          message.error("Passwords do not match. Please try again."); // Error message for mismatched passwords
        }
        break;

      default:
        break;
    }
  };

  // Render the form based on the current step
  const renderForm = () => {
    switch (currentStep) {
      case 0:
        return (
          <Form onFinish={handleFormFinish} style={formStyle}>
            <Form.Item
              name="email"
              rules={[{ required: true, message: "Please input your email!" }]} // Validation rule
            >
              <Input placeholder="Enter your email" className="w-full" />
            </Form.Item>
            <Form.Item>
              <div className="flex justify-end">
                <Button type="primary" htmlType="submit">
                  Ask OTP
                </Button>
              </div>
            </Form.Item>
          </Form>
        );

      case 1:
        return (
          <Form onFinish={handleFormFinish} style={formStyle}>
            <Form.Item
              name="verify_otp"
              rules={[{ required: true, message: "Please enter the OTP!" }]} // Validation rule
            >
              <Input placeholder="Enter OTP" className="w-full" />
            </Form.Item>
            <Form.Item>
              <div className="flex justify-end">
                <Button type="primary" htmlType="submit">
                  Verify OTP
                </Button>
              </div>
            </Form.Item>
          </Form>
        );

      case 2:
        return (
          <Form onFinish={handleFormFinish} style={formStyle}>
            <Form.Item
              name="password"
              rules={[
                { required: true, message: "Please enter your new password!" },
              ]} // Validation rule
            >
              <Input
                placeholder="Enter your new password"
                className="w-full"
                type="password" // Mask password input
              />
            </Form.Item>
            <Form.Item
              name="new_password"
              rules={[
                {
                  required: true,
                  message: "Please re-enter your new password!",
                },
              ]} // Validation rule
            >
              <Input
                placeholder="Re-enter your new password"
                className="w-full"
                type="password" // Mask password input
              />
            </Form.Item>
            <Form.Item>
              <div className="flex justify-end">
                <Button type="primary" htmlType="submit">
                  Submit
                </Button>
              </div>
            </Form.Item>
          </Form>
        );

      default:
        return null; // No form to display
    }
  };

  const formStyle = {
    width: "400px",
    border: "2px",
    marginTop: "1rem",
  };

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center border p-4 rounded-lg shadow-md">
        <Link to="/">
          <Avatar
            shape="square"
            src={LOGO}
            style={{ width: "400px", height: "100px" }} // Set desired width and height
          />
        </Link>

        <div className="mt-[.5rem] text-gray-500">Reset Password Here!</div>
        {renderForm()}
      </div>
    </div>
  );
};

export default ForgotPassword;
